<template>
  <section class="welcome" :class="{'steps_spacing': session && !session.is_legacy}">
    <b-row class="my-header-container">
      <b-col>
        <div v-if="hasSlot('product')" class="product-container-top">
          <div class="product"><slot name="product"></slot></div>
        </div>
        <h2 v-if="hasSlot('default')" :class="titleClass"><slot></slot></h2>
        <div v-if="hasSlot('subtitle')" class="subtitle"><slot name="subtitle"></slot></div>
        <div v-if="hasSlot('product')" class="product-container-middle">
          <div class="product"><slot name="product"></slot></div>
        </div>
        <hr v-if="hr">
        <div v-if="hasSlot('content')" class="content" :class="{'app__content': session && !session.is_legacy}">
          <div class="content-width"><slot name="content"></slot></div>
        </div>
        <div v-if="session && session.step_static_data && hasSlot('static-data')"><slot name="static-data"></slot></div>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import {InputType} from '@/constants'

export default {
  name: 'StepTitle',
  props: {
    hr: {
      type: Boolean,
      default: function() {
        return false
      }
    }
  },
  computed: {
    ...mapState(['session', 'popupSession']),
    ...mapGetters(['isSessionUserKnown']),
    titleClass: function() {
      if (this.isSessionUserKnown && this.popupSession && this.popupSession.step_type === InputType.Confirmation) {
        return 'welcome__label'
      }
      return 'title'
    }
  },
  methods: {
    hasSlot: function(name) {
      return this.$slots && this.$slots[name] && this.$slots[name].length
    }
  }
}
</script>
<style scoped>
</style>
